import LeftBanner from "../../components/LeftColumnBanner";
import React, { Fragment, useEffect, useState } from "react";
import {
	FormControl,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@material-ui/core";
import ErrorPopUp from "../../components/ErrorPopUp";
import { useSelector } from "react-redux";
import { useTouristDocumentTitle } from "../../lib/useTouristDocumentTitle";

const SmsLang = (props) => {
	useTouristDocumentTitle();

	const isTourist = useSelector((state) =>
		Boolean(state?.BalanceReducer?.payloadAfterLogIn?.isTourist),
	);
	const [value, setValue] = React.useState("");
	const [openErrorPopUp, setOpenErrorPopUp] = useState(false);
	const [changeSuccess, setSChangeSuccess] = useState(false);

	const { t, smsLangChange, changedLang, errorMessageHandlerSms } = props;

	useEffect(() => {
		if (changedLang) {
			setSChangeSuccess(true);
		} else if (errorMessageHandlerSms) {
			setOpenErrorPopUp(true);
		}
	}, [changedLang, errorMessageHandlerSms]);

	const handleChange = (event) => {
		setValue(event.target.value);
	};

	return (
		<Fragment>
			<div className="wrapper">
				<div className="row row-spacer">
					<LeftBanner />
					<div className="col-xs-6 active main-column-width">
						<div className="searchFilterContainer">
							<div className="box topBox mainContent withContent">
								<span className={`sectionTitle ${isTourist ? "tourist" : ""}`}>
									{t("chooseLangTitle")}
								</span>
							</div>
							<div
								className="box detailsBox"
								style={isTourist ? { color: "#212121" } : undefined}
							>
								<div className="packageInfoTitle textb">
									{t("chooseLangContent")}
								</div>
								<FormControl>
									<RadioGroup
										aria-labelledby="demo-controlled-radio-buttons-group"
										name="controlled-radio-buttons-group"
										value={value}
										onChange={handleChange}
									>
										<FormControlLabel
											value="greek"
											control={<Radio />}
											label={t("langGr")}
										/>
										<FormControlLabel
											value="english"
											control={<Radio />}
											label={t("langEn")}
										/>
									</RadioGroup>
								</FormControl>
								<div className="button-right">
									<div className="buttonOuter">
										<a
											className={`button primaryButton primaryButtonNormal${value === "" ? " disabled" : ""}`}
											onClick={() => {
												smsLangChange(value);
											}}
										>
											{t("save")}
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xs-3 left-column-hide"></div>
				</div>
			</div>
			{openErrorPopUp ? (
				<ErrorPopUp
					setOpenErrorPopUp={setOpenErrorPopUp}
					openErrorPopUp={openErrorPopUp}
					t={t}
					text={t("errorGeneral")}
				/>
			) : null}
			{changeSuccess ? (
				<div className="hover_bkgr_terms_container_prof popup_open">
					<div className="simple-popup">
						<div className="simple-popup-content simple-popup-content-payment">
							<span className="modalTitle">{t("chooseLangTitle")}</span>
							<div className="paymentContent firstElement">
								<div className="removePayments">
									<div className="paymentContentTitle textc comsote-green">
										<h1>
											{t("smsLangCongratsThankYou")}
											<br />
											{t("smsLangSuccess")}
										</h1>
									</div>
								</div>
								<div className="buttonOuter inlineButtons textCenter">
									<a
										href="/"
										className="button primaryButton primaryButtonNormal"
									>
										{t("returnHome")}
										<span className="loadingSpinner"></span>
									</a>
								</div>
								<div
									className="close"
									onClick={() => {
										setSChangeSuccess(false);
									}}
								></div>
							</div>
						</div>
					</div>
				</div>
			) : null}
		</Fragment>
	);
};

export default SmsLang;
